import React from 'react';

const ErrorPage = () => {
  return (
    <div id="content">
      <div className="error-page">
        <img src="/images/error-page/page-not-found.jpg" alt="Page not found" style={{ display: 'block', maxWidth: '100%', margin: '0 auto' }} />
      </div>
    </div>
  );
};

export default ErrorPage;
